import { ButtonTypeTokens, InputStateToken, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { api } from '../../../configs/api';
import { getAppHeader } from '../../../configs/config';
import SharedPropsService from '../../../SharedPropsService';
let aadharNumber = '';
export const onChangeAadhar = async (action, _datastore, {}) => {
    aadharNumber = action.payload.value;
};
export const toggleCTA = async (action, _datastore, { setDatastore }) => {
    await setDatastore(action.routeId, action.payload.targetWidgetId, {
        type: action.payload.value
            ? ButtonTypeTokens.LargeFilled
            : ButtonTypeTokens.LargeOutline,
    });
};
export const triggerCTA = async (action, _datastore, { network, navigate, setDatastore }) => {
    await setDatastore(action.routeId, 'continue', {
        loading: true,
    });
    action.payload.aadhaarNumber = aadharNumber;
    const applicationId = (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    const response = await network.post(api.aadharInit, { applicationId, aadhaarNumber: aadharNumber }, { headers: await getAppHeader() });
    await setDatastore(action.routeId, 'continue', {
        loading: false,
    });
    if (response.status === 200) {
        await navigate(ROUTE.KYC_AADHAAR_VERIFICATION_OTP, {
            appId: applicationId,
            aadNum: aadharNumber,
        });
    }
    else {
        await setDatastore(action.routeId, 'input', {
            state: InputStateToken.ERROR,
            caption: { error: response.data.message },
        });
    }
};
export const GoBackAction = async (action, _datastore, { goBack }) => {
    await goBack();
};
